import React from "react";
import { ListItemIcon, ListItemText, ListItem, Link } from "@material-ui/core";
import logo from "../../assets/warhammer-logo-white.png";

const HeaderBranding: React.FC = () => {
  return (
    <Link
      data-testid="appHeaderBarHomeLink"
      href="/"
      color="initial"
      style={{
        color: "white",
        display: "inline-block",
        textDecoration: "none",
      }}
    >
      <ListItem dense disableGutters>
        <ListItemIcon>
          <img
            src={logo}
            data-testid="appHeaderBarLogo"
            style={{ height: 45, width: 45, padding: 3 }}
            alt=""
          />
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={{ component: "h3" }}
          primary="My Warhammer"
          data-testid="appHeaderBarTitle"
        />
      </ListItem>
    </Link>
  );
};

export default HeaderBranding;
